function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'svart': 'rgb(15, 14, 15)','brun': 'rgb(48, 36, 26)','hvit': 'rgb(244, 240, 224)','gra': 'rgb(159, 152, 152)','lys-gra': 'rgb(205, 205, 205)','bla': 'rgb(38, 91, 162)','marinebla': 'rgb(31, 42, 68)','mork-bla': 'rgb(38, 40, 50)','kullgra': 'rgb(69, 68, 73)','grafitt': 'rgb(54, 55, 58)','mork-gra': 'rgb(85, 89, 94)','mellomgra': 'rgb(133, 137, 140)','roykt-gra': 'rgb(162, 166, 165)','solvgra': 'rgb(196, 199, 201)','krem': 'rgb(216, 174, 134)','beige': 'rgb(200, 183, 154)','khaki': 'rgb(168, 154, 109)','mork-brun': 'rgb(74, 55, 40)','olivengronn': 'rgb(107, 112, 67)','mork-gronn': 'rgb(46, 70, 54)','hvit-floyel': 'rgb(244, 240, 224)','krem-floyel': 'rgb(216, 174, 134)','brun-floyel': 'rgb(92, 64, 51)','gronn-floyel': 'rgb(62, 92, 75)','svart-floyel': 'rgb(20, 19, 26)',};

    this.images = {'gronn': 'url("//www.dekamund.com/cdn/shop/files/gronn_68x.png?v=9213442087168654150")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
